import { lang } from "../../i18nLang";

export class MeasurementBilledException extends Error {
  protected _code: string;

  constructor() {
    super(lang("measurements.error.updateBilled"));

    this.name = "MeasurementBilledException";
    this._code = "measurementBilled";
  }
}

export class SendToBillingException extends Error {
  protected _code: string;

  constructor() {
    super(lang("measurements.error.sendToBilling"));

    this.name = "SendToBillingException";
    this._code = "sendToBilling";
  }
}

export class NoItemsToBillingException extends Error {
  protected _code: string;

  constructor() {
    super(lang("measurements.error.noItemsToBilling"));

    this.name = "NoItemsToBillingException";
    this._code = "noItemsToBilling";
  }
}

export class ValueGreaterThanBalanceException extends Error {
  protected _code: string;

  constructor() {
    super(lang("measurements.error.valueGreaterThanBalance"));

    this.name = "ValueGreaterThanBalanceException";
    this._code = "valueGreaterThanBalance";
  }
}

export class ZeroUnitValueException extends Error {
  protected _code: string;

  constructor() {
    super(lang("measurements.error.zeroUnitValue"));

    this.name = "ZeroUnitValueException";
    this._code = "zeroUnitValue";
  }
}
